export const INFO_INITIAL_CONCOURSE = "INFO_INITIAL_CONCOURSE"
export const NEXT_FORM_PREV_CONCOURSE = "NEXT_FORM_PREV_CONCOURSE"
export const SAVE_FORM_CONCOURSE = "SAVE_FORM_CONCOURSE"
export const SAVE_FORM_DATA_GLOBAL_CONCOURSE = "SAVE_FORM_DATA_GLOBAL_CONCOURSE"